import { PaymentInfoModal } from './PaymentInfoModal';

export { PaymentInfoModal };
